import { BCCodeViewer } from '@/components/reference/BCCodeViewer';

export const PortalBCCodePage = () => (
  <div className="flex flex-col gap-3 h-full">
    <div>
      <h1 className="text-xl font-bold text-[#2C1810]">BC Building Code</h1>
      <p className="text-sm text-gray-500 mt-0.5">Look up code values fast — always confirm in the code text.</p>
    </div>
    <BCCodeViewer canUpload={false} />
  </div>
);
